<template>
  <div id="typeOne" class="question-detail">
    <answer-detail-line title="题型分"></answer-detail-line>
    <div id="questionTypeOne" class="question-type-score">
      <div class="head">
        <span>题型</span>
        <span>实得分 / 应得分</span>
      </div>
      <div class="body">
        <div v-for="(item, index) of quesTypeDetail" :key="index" class="body-row">
          <span class="name">{{ item.name }}</span>
          <div class="score">
            <span class="scoreF">{{ item.score }}</span>
            <span class="scoreS">/ {{ item.total }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="typeTwo" class="question-detail">
    <answer-detail-line title="明细分"></answer-detail-line>
    <div id="questionTypeTwo" class="question-type-score">
      <table border=0 cellpadding="0" cellspacing="0">
        <thead>
          <tr ref="trHead">
            <td style="width: 25%; padding-left: 10px;">试题序号</td>
            <td style="width: 35%;">实得分/应得分</td>
            <td style="width: 20%;">答题次数</td>
            <td style="width: 25%; text-align: right">答题用时</td>
          </tr>
        </thead>
       <tbody>
          <tr style="height: 40px;" v-for="(item, index) of tableDetail" :key="index">
            <td style="color: #999;">{{ item.quesSerial }}）</td>
            <td>
              <span>{{ item.score }}</span>
              &nbsp;
              <span style="color: #999;">/ {{ item.total }}</span>
            </td>
            <td>{{ item.retryCount }}次</td>
            <td style="padding-left: 15px;">{{ item.timeUsed }}s</td>
          </tr>
       </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { onUpdated } from 'vue'
import AnswerDetailLine from './answerDetailLine.vue'
export default {
  name: 'QuestionDetail',
  components: { AnswerDetailLine },
  props: {
    tableDetail: {
      type: Array,
      default() {
        return []
      }
    },
    // 题型分数据
    quesTypeDetail: {
      type: Array,
      default() {
        return []
      }
    }
  },
  setup () {
    onUpdated(() => {
      adjustmentHeight()
    })
    const adjustmentHeight = () => {
      const height = document.getElementById('questionTypeOne').clientHeight
      const heightTwo = document.getElementById('questionTypeTwo').clientHeight
      const finaHeight = height + 50
      const finaHeightTwo = heightTwo + 50
      document.getElementById('typeOne').style.height = `${finaHeight}px`
      document.getElementById('typeTwo').style.height = `${finaHeightTwo}px`
    }
    return { adjustmentHeight }
  }
}
</script>
<style lang="scss" scoped>
@import 'scss/color.scss';
.question-detail {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 702px;
  padding: 30px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 16px 16px 0px 0px;
  margin-top: 20px;
  box-shadow: 0 5px 14px 0 rgba(0, 0, 0, .05);
  .question-type-score {
    display: flex;
    flex-direction: column;
    width: 100%;
    .head {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-top: 40px;
      span {
        font-size: 26px;
        color: #999;
      }
    }
    .body {
      display: flex;
      flex-direction: column;
      &-row {
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        .name {
          font-size: 30px;
          color: #333
        }
        .score {
          display: flex;
          font-size: 30px;
          .scoreF {
            color: #333;
          }
          .scoreS {
            color: $color-gray;
            margin-left: 20px;
          }
        }
      }
    }
    table {
      margin-top: 40px;
      thead {
        tr {
          td {
            font-size: 26px;
            color: $color-gray;
            text-align: center;
          }
        }
      }
      tbody {
        tr {
          td {
            padding-top: 40px;
            font-size: 30px;
            color: #333;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
